
/**
  * Handle Pusher Message
  * This passes along the pusher event to the store to handle any redux state manipulation
  * Use the same eventType passed from pusher in the reducer's case statement
  * @param eventType - event name from pusher
  * @param message - data from pusher message
  */
export const handlePusherMessage = (eventType, message) => (dispatch) => {
  return dispatch({
    type: eventType,
    payload: message
  })
}
